import {JsonConvert} from 'json2typescript';

export class Json2TypescriptUtil {
    private static jsonConvert:JsonConvert = new JsonConvert();

     static getJsonConvertInstance():JsonConvert {
            return Json2TypescriptUtil.jsonConvert;
    }
}
